import { j as r } from '../../../_virtual/jsx-runtime.js';
const f = ({ children: c, iconSrc: e, iconName: a, iconPosition: s, icon: t, ...n }) => {
  const i =
      'flex w-fit items-center justify-center text-primary-600 cursor-pointer text-sm font-bold md:text-base',
    p =
      'focus:border-focus-600 focus:ring-2  focus:ring-focus-600 focus:py-0 focus:outline-none focus:border-b-0 focus:rounded-md ',
    u = 'visited:text-secondary-600 visited:border-secondary-600',
    d = 'inline-block w-5 h-5',
    l = `${s === 'after' ? 'ml-2' : 'mr-2'} text-primary-600 transition-colors visited:text-secondary-600 group-active:text-primary-800 `,
    m =
      'border-b py-0 px-2 group-hover:border-transparent group-focus:border-opacity-0 group-active:text-primary-800 group-active:bg-primary-100 group-active:border-opacity-0 lg:px-2 lg:group-focus:py-0',
    o = t || (e ? /* @__PURE__ */ r.jsx('img', { src: e, alt: a || '', className: d }) : null);
  return /* @__PURE__ */ r.jsxs('a', {
    className: `group  ${i}  ${u} ${p} ${s === 'after' ? 'flex-row-reverse' : ''}`,
    ...n,
    children: [
      o && /* @__PURE__ */ r.jsx('span', { className: ` ${l} `, children: o }),
      /* @__PURE__ */ r.jsx('span', { className: `${m}`, children: c }),
    ],
  });
};
export { f as TextLink };
